import { render, staticRenderFns } from "./CreateChannel.vue?vue&type=template&id=7d3be9d2&lang=pug"
import script from "./CreateChannel.vue?vue&type=script&lang=js"
export * from "./CreateChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d3be9d2')) {
      api.createRecord('7d3be9d2', component.options)
    } else {
      api.reload('7d3be9d2', component.options)
    }
    module.hot.accept("./CreateChannel.vue?vue&type=template&id=7d3be9d2&lang=pug", function () {
      api.rerender('7d3be9d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/channels/CreateChannel.vue"
export default component.exports